export default "__VITE_ASSET__DdMmr_RL__"